// 导入CompsForm的FormItemConfig接口
import type { FormItemConfig } from "@ms/shared-components/comps/CompsForm";

// 创建/编辑管理员弹窗配置
export const createEditModalConfig = {
  width: 600,
  height: "auto",
  layout: "horizontal" as const,
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  okText: "确定",
  cancelText: "取消",
  modalProps: {
    destroyOnHidden: true,
    width: 600,
  },
} as const;

// 创建管理员表单配置
export const createAdminFormConfig: FormItemConfig[] = [
  {
    name: "admin_account",
    label: "管理员账号",
    type: "input",
    rules: [
      { required: true, message: "请输入管理员账号" },
      { min: 3, message: "账号至少3个字符" },
    ],
    props: {
      placeholder: "请输入管理员账号",
      size: "large",
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: false,
      id: "create-admin-account",
    },
  },
  {
    name: "password",
    label: "初始密码",
    type: "input",
    rules: [
      { required: true, message: "请输入初始密码" },
      { min: 6, message: "密码至少6个字符" },
    ],
    props: {
      placeholder: "请输入初始密码",
      type: "password",
      size: "large",
      autoComplete: "new-password",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: false,
      id: "create-admin-password",
    },
  },
  {
    name: "description",
    label: "管理员描述",
    type: "textarea",
    rules: [
      { max: 500, message: "描述不能超过500个字符" },
    ],
    props: {
      placeholder: "请输入管理员描述（可选）",
      rows: 3,
      maxLength: 500,
      showCount: true,
      size: "large",
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: false,
      id: "create-admin-description",
    },
  },
];

// 编辑管理员表单配置
export const editAdminFormConfig: FormItemConfig[] = [
  {
    name: "admin_account",
    label: "管理员账号",
    type: "input",
    rules: [
      { required: true, message: "请输入管理员账号" },
      { min: 3, message: "账号至少3个字符" },
    ],
    props: {
      placeholder: "请输入管理员账号",
      size: "large",
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: false,
      id: "edit-admin-account",
    },
  },
  {
    name: "description",
    label: "管理员描述",
    type: "textarea",
    rules: [
      { max: 500, message: "描述不能超过500个字符" },
    ],
    props: {
      placeholder: "请输入管理员描述（可选）",
      rows: 3,
      maxLength: 500,
      showCount: true,
      size: "large",
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: false,
      id: "edit-admin-description",
    },
  },
];
